import Solution from "./solution";
import compare from "../../Utils/compare";

const testCases = [
  {
    arr: [1, 2, 3, 4],
    cb: (elm) => elm > 2,
  },
  {
    arr: [1, 2, 3, 4],
    cb: (elm) => elm % 2 === 0,
  },
  {
    arr: [1, 2, 3, 4],
    cb: (elm) => elm % 2 !== 0,
  },
  {
    arr: ["spray", "limit", "elite", "exuberant", "destruction", "present"],
    cb: (elm) => elm.length > 6,
  },
  {
    arr: ["spray", "limit", "elite", "exuberant", "destruction", "present"],
    cb: (elm) => elm.length < 6,
  },
];

const test = (code) => {
  try {
    const updatedFunc = `${code.trim()}`;
    const output = new Function(updatedFunc);
    for (let test of testCases) {
      const { arr, cb } = test;
      let outcome1 = output()(arr, cb);
      let outcome2 = Solution(arr, cb);
      const result = compare(outcome1, outcome2);
      if (!result) {
        return {
          status: "failed",
          details: { input: test, output: outcome1, expected: outcome2 },
        };
      }
    }

    return { status: "success", details: {} };
  } catch (e) {
    return {
      status: "error",
      details: { message: `${e.name}: ${e.message}` },
    };
  }
};

export default test;
